export default "__VITE_ASSET__CKmeTjyL__"